<template>
  <a-modal
    v-model="visible"
    :footer="null"
    :title="null"
    :width="800"
    wrapClassName="appoint-scs-modal"
    destroy-on-close
  >
    <div class="appoint-scs-content">
      <svg-icon icon-class="appoint-scs" class-name="appoint-scs"></svg-icon>
      <div class="t1">{{$t('home.AppointmentSucc')}}</div>
      <div class="t2">{{theme}}</div>
      <div class="t3">{{showTime}}</div>
      <svg-icon
        :icon-class="calendarIcon"
        class-name="calendar"
        @click.native="handleImportCalendar"
        @mouseenter.native="calendarIcon='calendar-active'"
        @mouseleave.n.native="calendarIcon='calendar-default'"
      ></svg-icon>
      <div class="t4">{{$t('home.AddCalendar')}}</div>
    </div>
    <div class="btn-container">
      <BasicBtnGroup
        @primeClick="handleCopyInvitationLink"
        @defClick="viewDetail"
        class="basic-btns"
      >
        <span slot="defContent">{{$t('home.ViewDetails')}}</span>
        <span slot="primaryContent">{{$t('home.CopyInvitationLink')}}</span>
      </BasicBtnGroup>
    </div>
    <CopyInvitationLinkMixin />
  </a-modal>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import BasicBtnGroup from '@/components/behavior/basic-btn-group/index.vue'
import moment from 'moment'
import { exportCalendar } from '@/utils/ops'
import CopyInvitationLinkMixin from '@/components/business/copy-invitation-link-mixin/index.vue'

export default {
  name: 'AppointmentSuccessful',
  mixins: [CopyInvitationLinkMixin],
  components: {
    BasicBtnGroup,
    CopyInvitationLinkMixin
  },
  data() {
    return {
      visible: false,
      theme: '',
      beginTime: '',
      endTime: '',
      conferenceId: '',
      conferenceDetail: {},
      calendarIcon: 'calendar-default'
    }
  },
  computed: {
    showTime() {
      if (moment.unix(this.beginTime).isSame(moment.unix(this.endTime), 'day')) {
        return moment.unix(this.beginTime).format('YYYY-MM-DD dddd HH:mm') + ' - ' + moment.unix(this.endTime).format('HH:mm')
      }
      return moment.unix(this.beginTime).format('YYYY-MM-DD dddd HH:mm') + ' - ' + moment.unix(this.endTime).format('YYYY-MM-DD dddd HH:mm')
    }
  },
  methods: {
    ...mapMutations('coc', ['setCurrentCocId']),
    ...mapActions('coc', ['fetchCocDetail', 'refreshCoc']),
    viewDetail(){
      this.setCurrentCocId(this.conferenceId)
      this.visible = false
    },
    async init(conferenceId) {
      this.visible = true
      this.conferenceId = conferenceId
      const response = await this.refreshCoc(conferenceId)
      this.conferenceDetail = response
      this.theme = response.theme
      this.beginTime = response.beginTime
      this.endTime = response.endTime

      await this.handleSetInvitationLinkOfData(this.conferenceDetail)
    },
    handleImportCalendar() {
      const { beginTime, endTime, theme, tags } = this.conferenceDetail
      const cocTags = tags.map(({ name }) => name).join('、')
      exportCalendar({ start: new Date(beginTime * 1000), end: new Date(endTime * 1000), subject: theme, description: `${this.$t('home.CollaborationType')}: ${cocTags}` })
    }
  },
}
</script>

<style scoped lang="less">
.text(@height, @fontSize, @fontWeight, @color, @marginTop) {
  height: @height;
  line-height: @height;
  font-size: @fontSize;
  font-weight: @fontWeight;
  color: @color;
  margin-top: @marginTop;
}
::v-deep .appoint-scs-modal {
  .ant-modal {
    .ant-modal-content {
      box-shadow: 0 10px 20px 0 rgba(62, 85, 132, 0.3);
      border-radius: 16px;
      border: 1px solid #EDEFF2;
      .ant-modal-body {
        height: 600px;
        .appoint-scs-content {
          display: flex;
          flex-direction: column;
          align-items: center;
          .appoint-scs {
            width: 88px;
            height: 88px;
            margin-top: 56px;
          }
          .t1 {
            .text(40px,28px,600,#333,32px)
          }
          .t2 {
            .text(25px,18px,500,#000,40px)
          }
          .t3 {
            .text(22px,16px,400,#6A6D73,12px)
          }
          .calendar {
            width: 40px;
            height: 40px;
            margin-top: 32px;
            cursor: pointer;
          }
          .t4 {
            .text(22px,16px,400,#6A6D73,8px)
          }
        }
        .btn-container {
          display: flex;
          justify-content: space-around;
          margin-top: 53px;
          .ant-btn {
            width: 144px;
            height: 50px;
            border-radius: 25px;
            padding: 0;
          }
          .default-btn {
            margin-right: 56px;
          }
        }
      }
    }
  }
}
</style>
